import updatePaymentType from './updatePaymentType';
import updateEstimatorValues from './updateEstimatorValues';
import updateShowModalFlag from './updateShowModalFlag';

const Mutation = {
  updatePaymentType,
  updateEstimatorValues,
  updateShowModalFlag
};

export default Mutation;
